import * as angular from "angular";
import formRenderer from "./components/form";
import type { FormHandle } from "./FormHandle";
import type { JsonSchemaDefinition } from "./types";
import type {
	FormOptions,
	FormValidationResult
} from "./components/form-session";
import template from "./json-schema-form.html";

/** Bridge the canonical renderer to the host AngularJS ngModel contract. */
export interface JsonSchemaFormController {
	schema: JsonSchemaDefinition;

	options?: FormOptions;

	formControl?: FormHandle;

	ngModel: angular.INgModelController;

	validationResult?: FormValidationResult;
}

// AngularJS owns the merged binding and required-controller properties.
// eslint-disable-next-line no-redeclare
export class JsonSchemaFormController implements angular.IController {
	public static $inject = ["$scope"];

	public model: unknown;

	private stopValidityWatch?: () => void;

	public constructor(private readonly $scope: angular.IScope) {}

	public $onInit(): void {
		this.ngModel.$render = () => {
			this.model = angular.copy(this.ngModel.$viewValue);
		};

		this.stopValidityWatch = this.$scope.$watch(() => this.validationResult, result => {
			if(result) {
				this.ngModel.$setValidity("jsonSchema", result.valid);
			}
		});
	}

	public $onDestroy(): void {
		this.formControl = undefined;
		this.stopValidityWatch?.();
	}

	public publish(value: unknown, result?: FormValidationResult, reset = false): void {
		if(result) {
			this.validationResult = result;
		}

		if(!angular.equals(value, this.ngModel.$viewValue)) {
			this.ngModel.$setViewValue(angular.copy(value));
		}

		if(reset) {
			this.ngModel.$setPristine();
			this.ngModel.$setUntouched();
		}

		this.options?.onChange?.(value);
	}
}

export const jsonSchemaFormComponent: angular.IComponentOptions = {
	controller: JsonSchemaFormController,
	template,
	bindings: {
		schema: "<",
		options: "<?",
		formControl: "=?",
		validationResult: "=?"
	},
	require: { ngModel: "ngModel" }
};

export default angular.module("vesl.extensions.json-schema.form", [formRenderer])
	.component("jsonSchemaForm", jsonSchemaFormComponent)
	.name;
